{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              154.30942335205015,
              -34.78729694071991
            ],
            [
              155.16069324812622,
              -24.670573918216917
            ],
            [
              143.26989373187757,
              -9.969953015146217
            ],
            [
              127.49528803329429,
              -9.838326062416542
            ],
            [
              110.4593650286659,
              -22.946590516508977
            ],
            [
              112.8679993785156,
              -36.54186948106209
            ],
            [
              148.8209354696881,
              -45.83169560173039
            ],
            [
              154.30942335205015,
              -34.78729694071991
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}